//Custom Element Register
if (!customElements.get('rxc-activator')) {
  let hasAutoOpenedFromNav = false;

  class RXCActivator extends HTMLElement {
    constructor() {
      super();
      this.singletonCheck();
      this.activatorBtn = null;
      this.isLoading = false;
      this.shopUrl = null;
      this.proxyPath = null;
      this.rxcFrameId = null;
      this.rxcFrameTitle = null;
      this.rxcErrorMsg = null;
      console.log('[Shopify RXCActivator] Init - Mounting');
      this.activatorBtn = this.querySelector("[name='rxc-activator']");
      this.addToBagBtn = document.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
      this.stickyAddToBagBtn = document.querySelector('arn-intersection-sticky atc-ref-btn button');
      this.params = new URLSearchParams(window.location.search);
    }

    connectedCallback() {
      document.addEventListener("prescription-lenses-click", () => {
        this.activatorBtn?.click();
      })
      // If variant is not available do nothing
      //   commented to fix issue with CTAs when page is loaded with OOS variant and then user select an available one
      // if(!this.isVariantAvailable()) return;

      this.checkMocoAvailability();

      // Keep #data-rxc-frame offerPrice aligned with the DK price as soon as the
      // discount engine resolves codes (it runs async / patches the price client-side).
      this.patchDkOfferPrices();
      document.addEventListener('arn:dk:discount-codes-changed', this.dkCodesChangedHandler);

      // Show button when location changed
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        document.querySelector(".product-form__buttons")?.classList.add("tw-hidden");
        // If variant is not available do nothing
        if(!this.isVariantAvailable()) {
          document.querySelector(".product-form__buttons")?.classList.remove("tw-hidden");
          return;
        }
        // if (this.activatorBtn) this.activatorBtn.style.display = "block";
        console.log("variant change - checking MoCo availability");
        this.checkMocoAvailability();
        this.patchDkOfferPrices();
        document.querySelector(".product-form__buttons")?.classList.remove("tw-hidden");
      });
      // Hide button when selected new face size
      subscribe(PUB_SUB_EVENTS.faceSizeSelection, () => {
        document.querySelector(".product-form__buttons")?.classList.add("tw-hidden");
        if (this.activatorBtn) this.activatorBtn.style.display = "none";
        //this.checkMocoAvailability();
      });
    }

    isVariantAvailable(){
      //check if data-btn-status exist in the DOM
      if(this.dataset.preorder == "true") return false;
      if(!document.querySelector("[data-btn-status]")) return true;
      return document.querySelector("[data-btn-status='product_ok']") ? true : false;
    }

    checkMocoAvailability() {
      const market = this.activatorBtn.getAttribute('data-market');

      // Estrai e normalizza l'handle
      const urlSlices = window.location.pathname.split('/');
      const productHandle = urlSlices[urlSlices?.length - 1];
      // const [modelCode, colorCode] = productHandle.split('-');
      // colorCode may contain dashes, so we need to join all parts except the first one and replace dashes with underscores
      const handleParts = productHandle.split('-');
      const modelCode = handleParts[0];
      const colorCode = handleParts.slice(1).join('_');
      const adaptedModelCode = modelCode.toUpperCase();
      const adaptedMoCo = modelCode.toUpperCase() + '__' + colorCode.toUpperCase();

      // Local variables
      const BASE_URL = 'https://assets.arnette.com/extra/image/rxcbe';
      const ENVIRONMENT = this.dataset.env;
      const BRAND_CODE = 'AN';

      this.fetchAvailability(
        BASE_URL,
        ENVIRONMENT,
        BRAND_CODE,
        market,
        adaptedModelCode,
        adaptedMoCo
      );
    }

    fetchAvailability(BASE_URL, ENVIRONMENT, BRAND_CODE, market, adaptedModelCode, adaptedMoCo) {
      let isMocoAvailable = false;
      let isModelAvailable = false;

      fetch(`${BASE_URL}/${ENVIRONMENT}/availability/${BRAND_CODE}/${market}/availability_${adaptedModelCode}.json`)
        .then(res => res.json())
        .then(res => {
          isMocoAvailable = res[adaptedMoCo]?.availability === true ? true : false;
          isModelAvailable = Object.keys(res).some(key => key.startsWith(adaptedModelCode + '__'));

          if (isMocoAvailable && isModelAvailable) {
            console.log("RXC - MoCo is available");
            this.displayPrescriptionCta(true);
            if(this.dataset.productType == "Optical") {
              this.removeExpressCheckout();
              if (this.addToBagBtn) this.addToBagBtn.style.display = 'none';
              this.activatorBtn.classList.remove("tw-arn-btn-outline");
              this.activatorBtn.classList.add("tw-arn-btn-filled");
              this.activatorBtn.classList.replace("data-[loading]:tw-arn-btn-outline-loading", "data-[loading]:tw-arn-btn-filled-loading");
              this.changeCopy(this.dataset.secondaryCopy);
              publish("select-lenses", {source: "rxc-activator", copy: this.dataset.secondaryCopy});
            }
            else {
              this.activatorBtn.classList.add("tw-arn-btn-outline");
              this.activatorBtn.classList.remove("tw-arn-btn-filled")
              this.changeCopy(this.dataset.primaryCopy);
            }
            this.activatorBtn.style.display = 'flex';
            this.activatorBtn.setAttribute('data-is-available', 'true');
          } else this.displayPrescriptionCta(false);

          if (isMocoAvailable) {
            this.isLoading = false;
            this.shopUrl = window.Shopify.routes.root != '/' ? window.location.host + window.Shopify.routes.root : window.location.host;
            this.proxyPath = market === 'US' ? 'rxc-us' : 'rxc';
            this.rxcFrameId = this.dataset.rxcFrameId || 'rxc-iframe';
            this.rxcFrameTitle = this.dataset.rxcFrameTitle || 'RXC - Lens Configurator';
            this.rxcErrorMsg = this.dataset.rxcErrorMsg || 'Error RXC Loading - Try later';

            window.addEventListener('message', this.window_messageHandler);
            this.activatorBtn?.addEventListener('click', this.activator_clickHandler);
            if (this.params.get('rxc-wishlist') === 'true') {
              this.activator_clickHandler(new Event('auto'));
            }

            const searchParams = new URLSearchParams(window.location.search);

            let rxcUrlContext = {
              isEditLenses: searchParams.get('isEditLenses') === 'true',
              isAddLenses: searchParams.get('isAddLenses') === 'true',
              frameUniqueId: searchParams.get('frameUniqueId'),
              lensUniqueId: searchParams.get('lensUniqueId'),
              orderItemId: searchParams.get('orderItemId'),
              frameSize: searchParams.get('size'),
            };

            const isEditingContext =
              rxcUrlContext.isEditLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.lensUniqueId && rxcUrlContext.orderItemId;
            const isAddContext = rxcUrlContext.isAddLenses && rxcUrlContext.frameUniqueId;

            if (isEditingContext || isAddContext) {
              this.setLoading(true);
              this.showFrame(rxcUrlContext);
            } else if (this.params.get('rxcnav') === 'Type' && !hasAutoOpenedFromNav) {
              hasAutoOpenedFromNav = true;
              this.activator_clickHandler(new Event('auto'));
            }
          }
        })
        .catch(error => {
          this.displayPrescriptionCta(false);
          this.activatorBtn.style.display = 'none';
          if (this.addToBagBtn) this.addToBagBtn.style.display = 'block';
          this.activatorBtn.setAttribute('data-is-available', 'false');
        });
    }

    changeCopy(copy) {
      const activatorSpan = this.activatorBtn.querySelector("#activator-span");
      if (activatorSpan) activatorSpan.innerHTML = copy;
    }

    removeExpressCheckout() {
      const expressCheckout = document.querySelector(`.shopify-payment-button`);
      if (expressCheckout) expressCheckout.style.display = "none";
    }

    displayPrescriptionCta(display) {
      document.querySelectorAll(".prescription-cta-link").forEach((cta) => cta.style.display = display ? "" : "none");
    }

    disconnectedCallback() {
      // console.log('[Shopify RXCActivator] Unmounting');
      window.removeEventListener('message', this.window_messageHandler);
      this.activatorBtn?.removeEventListener('click', this.activator_clickHandler);
      document.removeEventListener('arn:dk:discount-codes-changed', this.dkCodesChangedHandler);
    }

    dkCodesChangedHandler = () => this.patchDkOfferPrices();

    singletonCheck() {
      if (document.getElementsByTagName('rxc-activator').length > 1) {
        console.error('Multiple instances of <rxc-activator> detected. Only one instance is allowed.');
        return false;
      }
      return true;
    }

    setLoading(isLoading) {
      if (this.activatorBtn) {
        this.activatorBtn.toggleAttribute('data-loading', isLoading);
        this.activatorBtn.toggleAttribute('aria-disabled', isLoading);
        this.activatorBtn.classList.toggle('loading', isLoading);
        this.activatorBtn.ariaDisabled = isLoading;
        this.activatorBtn.disabled = isLoading;

        // disable add to cart button when loading
        if (this.addToBagBtn) {
          this.addToBagBtn.ariaDisabled = isLoading;
          this.addToBagBtn.disabled = isLoading;
        }
        // disable sticky add to cart button when loading
        if (this.stickyAddToBagBtn) {
          this.stickyAddToBagBtn.ariaDisabled = isLoading;
          this.stickyAddToBagBtn.disabled = isLoading;
        }
      }

      this.isLoading = isLoading;
    }

    activator_clickHandler = evt => {
      evt.preventDefault();

      if (!this.shopUrl) {
        console.error('Shop URL not found');
        return;
      }

      if (!this.isLoading) {
        this.setLoading(true);
        this.showFrame();
      }
    }

    redirectToCart() {
      const cartUrl = window.routes.cart_url || `${window.Shopify?.routes?.root || "/"}cart`;
      const separator = cartUrl.includes('?') ? '&' : '?';
      window.location.href = `${cartUrl}?disable_event=true`;
    }

    buildDkContext() {
      const raw = window.arnDkStorefrontContext || {};
      const engine = window.ArnDkStorefrontPrices;
      return {
        market: String(raw.market || '').toLowerCase().trim(),
        currency: String(raw.currency || '').toUpperCase().trim(),
        appliedCodes: engine?.getAppliedCodesCsv ? engine.getAppliedCodesCsv() : '',
        customerHasTestTag: Boolean(raw.customerHasTestTag),
      };
    }

    // DK code/cookie discounts are resolved client-side, so the server-rendered
    // offerPrice in #data-rxc-frame carries the full price. Recompute it with the
    // same engine that patches the PDP price before handing the data to RXC.
    patchDkOfferPrices() {
      const engine = window.ArnDkStorefrontPrices;
      const scriptEl = document.getElementById('data-rxc-frame');
      if (!engine || !scriptEl) return;

      const priceNode = document.querySelector('[data-arn-price][data-arn-dk-base-cents]');
      if (!priceNode || priceNode.dataset.arnDkManualSale === 'true') return;

      const discounts = engine.resolveDiscountsFromDataset(priceNode.dataset);
      if (!discounts.length) return;

      const ctx = this.buildDkContext();

      const toCents = (raw) => {
        const cleaned = String(raw).replace(/[^\d.,]/g, '');
        if (!cleaned) return 0;
        const lastSep = Math.max(cleaned.lastIndexOf('.'), cleaned.lastIndexOf(','));
        const intPart = lastSep === -1 ? cleaned : cleaned.slice(0, lastSep).replace(/[.,]/g, '');
        const decPart = lastSep === -1 ? '' : cleaned.slice(lastSep + 1).replace(/[.,]/g, '');
        const value = parseFloat(`${intPart || '0'}.${decPart || '0'}`);
        return Number.isFinite(value) ? Math.round(value * 100) : 0;
      };

      let data;
      try {
        data = JSON.parse(scriptEl.textContent);
      } catch {
        return;
      }

      let patched = false;
      Object.values(data).forEach((entry) => {
        if (!entry || typeof entry !== 'object') return;
        const baseCents = toCents(entry.listPrice);
        if (!baseCents) return;
        const best = engine.bestDkSaleCents(baseCents, discounts, ctx);
        if (best.hasDiscount) {
          entry.offerPrice = (best.saleCents / 100).toFixed(2);
          patched = true;
        }
      });

      if (patched) scriptEl.textContent = JSON.stringify(data);
    }

    showFrame(rxcUrlContext = {}) {
      this.patchDkOfferPrices();
      const urlParams = new URLSearchParams(window.location.search);

      const variantId = urlParams.get('variant') || this.activatorBtn.getAttribute('data-variant-id');
      const country = this.activatorBtn.getAttribute('data-market');
      const market = this.activatorBtn.getAttribute('data-market-id');
      const language = this.activatorBtn.getAttribute('data-language');
      const currency = this.activatorBtn.getAttribute('data-currency');

      const iframeUrl = new URL(`${window.location.protocol}//${this.shopUrl}/apps/${this.proxyPath}/prescription/index`);
      const iframe = document.getElementById(this.rxcFrameId) || document.createElement('iframe');

      if (rxcUrlContext && Object.keys(rxcUrlContext)?.length) {
        const isEditingContext =
          rxcUrlContext.isEditLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.lensUniqueId && rxcUrlContext.orderItemId;
        const isAddContext = rxcUrlContext.isAddLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.orderItemId;

        if (isAddContext) {
          iframeUrl.searchParams.set('isAddLenses', 'true');
          iframeUrl.searchParams.set('frameUniqueId', rxcUrlContext.frameUniqueId);
          iframeUrl.searchParams.set('orderItemId', rxcUrlContext.orderItemId);
        }

        if (isEditingContext) {
          iframeUrl.searchParams.set('isEditLenses', 'true');
          iframeUrl.searchParams.set('frameUniqueId', rxcUrlContext.frameUniqueId);
          iframeUrl.searchParams.set('lensUniqueId', rxcUrlContext.lensUniqueId);
          iframeUrl.searchParams.set('orderItemId', rxcUrlContext.orderItemId);
        }
      }

      iframeUrl.searchParams.set('rxc_cart_redirect_enabled', 'false');
      iframeUrl.searchParams.set('variantId', variantId);
      iframeUrl.searchParams.set('market', country);
      iframeUrl.searchParams.set('market_id', market);
      iframeUrl.searchParams.set('language', language);
      iframeUrl.searchParams.set('currency', currency);

      iframe.id = this.rxcFrameId;
      iframe.title = this.rxcFrameTitle;
      iframe.tabIndex = -1;
      iframe.src = iframeUrl.toString();

      iframe.onerror = () => {
        console.error('RXC App Embed Error');
        this.onRXCError();
      };

      iframe.toggleAttribute('data-loading', true);
      document.body.appendChild(iframe);
    }

    onFrameLoaded() {
      const rxcAppEmbed = document.getElementById(this.rxcFrameId);
      this.setLoading(false);
      publish("frame-loaded", {});

      if (!rxcAppEmbed) {
        console.error('RXC App Embed not found');
        return;
      }

      rxcAppEmbed.toggleAttribute('data-loading', false);
      rxcAppEmbed.toggleAttribute('data-ready', true);
    }

    onRXCError() {
      let messageTemplate = this.querySelector('p[data-rxc-error]') || document.createElement('p');
      messageTemplate.setAttribute('data-rxc-error', true);
      messageTemplate.textContent = this.rxcErrorMsg;
      this.activatorBtn.insertAdjacentElement('afterend', messageTemplate);
      this.setLoading(false);
    }

    normalizeRxcProductsForTealium(payload = {}) {
      if (!payload?.products || typeof payload.products !== 'object') {
        return null;
      }

      const fallbackUnits = String(
        payload.quantity ??
        payload.item?.quantity ??
        1
      );

      return Object.entries(payload.products).reduce((acc, [productKey, productData]) => {
        if (!productData || typeof productData !== 'object') {
          return acc;
        }

        const nextProductData = { ...productData };

        if (!('Status' in nextProductData)) {
          nextProductData.Status = nextProductData.status || 'Available';
        }

        if (
          (nextProductData.Units === undefined || nextProductData.Units === null || nextProductData.Units === '') &&
          fallbackUnits
        ) {
          nextProductData.Units = fallbackUnits;
        }

        delete nextProductData.status;
        acc[productKey] = nextProductData;
        return acc;
      }, {});
    }

    onRXCUpdatedCart(payload) {
      const products = this.normalizeRxcProductsForTealium(payload);

      if (
        products &&
        Object.keys(products).length > 0 &&
        typeof Fetchutils !== "undefined" &&
        typeof Fetchutils.sendTealiumData === "function"
      ) {
        const tealiumPayload = {
          id: 'Event',
          Events_CartAdd: '1',
          Products: products
        };

        Fetchutils.sendTealiumData(tealiumPayload);
      }

      window.location = window.routes.cart_url;
    }

    window_messageHandler = event => {
      const rxcAppData = event?.data?.rxcApp;

      if (!rxcAppData) return;

      switch (rxcAppData.type) {
        case 'RXC_IS_ON_ERROR':
          console.log('RXC_IS_ON_ERROR RECEIVED:', event.data);
          this.onRXCError();
          break;
        case 'RXC_LOADED':
          console.log('[Shopify RXCActivator] Message from RXC APP:', event.data);
          this.onFrameLoaded();
          break;
        case 'RXC_UPDATED_CART':
          this.onRXCUpdatedCart(rxcAppData.payload);
          break;
      }
    };
  }

  customElements.define('rxc-activator', RXCActivator);
}
